import { Component, Inject, OnInit, OnDestroy, Type } from '@angular/core';
import { IGetClass, IModalWindow } from '../../../utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from '../../../core/enums';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { DialogOperationEnum } from '../../../utils/enums/dialog-operation.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MimeTypesEnum } from 'src/app/utils/enums';
import { TranslateModule } from '@ngx-translate/core';
import { RemoveExtensionStringPipe } from 'src/app/utils/pipes/remove-extension-string.pipe';

@Component({
    selector: 'asg-filename-dialog',
    templateUrl: './filename-dialog.component.html',
    styleUrls: ['./filename-dialog.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatDialogModule, TranslateModule, RemoveExtensionStringPipe]
})
export class FilenameDialogComponent implements OnInit, OnDestroy, IModalWindow, IGetClass {
  private readonly subscriptions: Subscription = new Subscription();

  dlgOperationEnum: typeof DialogOperationEnum = DialogOperationEnum;

  mimeTypesEnum: typeof MimeTypesEnum = MimeTypesEnum;
  filename: string = '';
  mimetype: MimeTypesEnum | null = null;
  dialogOperation: DialogOperationEnum;
  filenameForm: FormGroup;

  constructor(
    // TODO: specify proper type here
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FilenameDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.filename = data.filename;
    this.mimetype = data.mimetype;
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getWindowType(): Type<IModalWindow> {
    return FilenameDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.FILENAME_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'filename-dlg';
  }

  ngOnInit(): void {
    this.dialogOperation = this.data.operation;
    this.createForm();
    this.onValueChanges();
  }

  closeDlg(filename: string): void {
    this.dialogRef.close(filename);
  }

  private createForm(): void {
    this.filenameForm = this.fb.group({
      filenameControl: [this.filename]
    });
  }

  private onValueChanges(): void {
    this.subscriptions.add(
      this.filenameForm.controls.filenameControl.valueChanges.subscribe((e) => {
        this.filename = e;
      })
    );
  }
}
